module.exports = __webpack_public_path__ + "images/emoji_2_colorb54edc16a1afed7555fc95f432d7f6e1.svg";